import Link from "next/link";

const CategoryBannerdata = ({ category,navData }) => {
  return (
    <>
      <div className="rbt-banner-content-top">
        <div className="container">
          {category && (
            <div className="row">
              <div className="col-lg-12">
                <ul className="page-list">
                  <li className="rbt-breadcrumb-item text-white">
                    <Link href="/">Home</Link>
                  </li>
                  <li>
                    <div className="icon-right">
                      <i className="feather-chevron-right"></i>
                    </div>
                  </li>
                  <li className="rbt-breadcrumb-item active text-white">
                    {category && category.category
                      ? category.category
                      : "Study Courses"}
                  </li>
                </ul>
                <div className=" title-wrapper">
                  <h1 className="title mb--0 text-white">
                    {" "}
                    {category && category.category
                      ? category.category
                      : "Study Courses"}
                  </h1>

                </div>
                <p className="description text-white">
                  {category && category.desc
                    ? category.desc
                    : "Let Global Study Pathways transform your educational aspirations into reality. Contact us today to start your journey toward international education!"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CategoryBannerdata;
